var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _class, _class2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

/**
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Component, Prop } from '@sick-davinci/ce-decorators';
import { style } from '../../_style/Common.style';
import { toCssColorValue } from '../../_utils/ColorTools.js';
import { AbstractBarChartGrouped } from './AbstractBarChartGrouped.js';
/**
 * A bar chart with grouped bars.
 * This chart supports logarithmic value ranges.
 *
 * @example
 * ```html
 * <div style="width: 400px; height: 300px">
 *   <davinci-bar-chart-grouped palette="secondary" values="[[480, 510, 490],[800, 900, 750],[750, 1100, 650]]" group-labels='["A","B","C"]' legend-labels='["one", "two", "three"]'></davinci-bar-chart-grouped>
 * </div>
 *  ```
 */

export let BarChartGrouped = (_dec = Component({
  tag: 'davinci-bar-chart-grouped',
  style
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", Object), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", Object), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", Object), _dec8 = Prop(), _dec9 = Reflect.metadata("design:type", Object), _dec(_class = (_class2 = class BarChartGrouped extends AbstractBarChartGrouped {
  /**
   * The labels to be used for the groups (one label per group).
   *
   * @default []
   */
  get groupLabels() {
    return this._getCategoryLabels();
  }

  set groupLabels(labels) {
    this._setCategoryLabels(labels);
  }
  /**
   * The icons to be used for the groups (one icon per group).
   *
   * @default []
   */


  get icons() {
    return this._getCategoryIcons();
  }

  set icons(icons) {
    this._setCategoryIcons(icons);
  }
  /**
   * The values to be used for the bars.
   * A two dimensional array; the first dimension denotes the index of the group the second dimension the index of the bar.
   * e.g. 'value[2][4]' stores the value of the 5th bar of the 3rd group
   *
   * Beware that the order of values should reflect the order of colors if the 'state' color palette is active.
   *
   * @default []
   *
   */


  get values() {
    return this._getValues();
  }

  set values(values) {
    this._setValues(values);
  }
  /**
   * The colors to be used for the bars of a group.
   * The first element denotes the color for the first bar of a group, the second element denotes the color for the second bar of a group and so on.
   *
   * Each entry of this array is either interpreted as an index referring to the selected palette, or a css-color-value designation (e.g. 'purple', '#ff00ff', 'rgba(255,255,128,0.5)')
   *
   * If there are more bars than colors the array will be traversed from the beginning
   *
   * @default all colors of the current color-palette
   */


  get colors() {
    return this._getSeriesColors();
  }

  set colors(value) {
    this._setSeriesColors(value);
  }
  /**
   * @override
   */


  _createStyle(hostFontFamily) {
    const style = super._createStyle(hostFontFamily);

    style.barColors = this._computeBarColors();
    return style;
  }
  /**
   * Computes the bar colors.
   *
   * The first dimension denotes the group, the second dimension the bar.
   *
   * @returns the colors to be used for the bars
   */


  _computeBarColors() {
    return [this._getSeriesColors().map(color => toCssColorValue(color, this.palette))];
  }

}, (_applyDecoratedDescriptor(_class2.prototype, "groupLabels", [_dec2, _dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "groupLabels"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "icons", [_dec4, _dec5], Object.getOwnPropertyDescriptor(_class2.prototype, "icons"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "values", [_dec6, _dec7], Object.getOwnPropertyDescriptor(_class2.prototype, "values"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "colors", [_dec8, _dec9], Object.getOwnPropertyDescriptor(_class2.prototype, "colors"), _class2.prototype)), _class2)) || _class);
